/*! images */
$(document).ready(function () {

    $('.blog-migrated p').each(function () {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
            $this.remove();
    });


    $('.blog-migrated img[data-original-height], .blog-migrated img[data-original-width]').each(function () {
        var $img = $(this);
        var $table = $img.closest('table');
        var $caption = $table.find('> tbody tr:nth-child(2) > td').html();
        var $figure = $("<figure>", { class: "figure center" });
        var $imageContainer = $("<div>", { class: "image-container" });
        var $figcaption = $("<figcaption>", { class: "figure-caption" });
        var width = $img.prop("width");
        var $target;

        // Find target location
        if ($table.length > 0) {
            $target = $table;
        } else {
            $target = $img.closest('p')
        }

        $img.addClass("img-fluid");
        $img.removeAttr("width", "auto");
        $img.removeAttr("height", "auto");

        $figure.attr("style", "width:" + width + "px");

        // Create Figure and insert
        $imageContainer.html($img);
        $figure.append($imageContainer);
        if ($caption && $caption.length > 0) {
            $figcaption.html($caption.replace(/&nbsp;/g, '').trim());
            $figure.append($figcaption);
        }
        $figure.insertAfter($target);

        // Remove target
        $target.remove();

        console.log($img);
        console.log($table);
        console.log($caption);
    });
});